/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Preview_DomainInputs */

const en_start_page_preview_domain = /** @type {(inputs: Start_Page_Preview_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`complete-athlete.co`)
};

const pl_start_page_preview_domain = /** @type {(inputs: Start_Page_Preview_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`complete-athlete.co`)
};

/**
* | output |
* | --- |
* | "complete-athlete.co" |
*
* @param {Start_Page_Preview_DomainInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_preview_domain = /** @type {((inputs?: Start_Page_Preview_DomainInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Preview_DomainInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_preview_domain(inputs)
	return en_start_page_preview_domain(inputs)
});